module.exports = __webpack_public_path__ + "static/media/ycard_amexp.cbf51b48.svg";